import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const OcrIndicatorService = {
    getAllToSelect: async () => axios.get(`${API_URL}/ocr_indicator/lanes/getAllToSelect`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
};

export default OcrIndicatorService;